import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() buttonText: string = '';
  @Input() buttonLink: string = '';

  @Output() inputChange = new EventEmitter<{
    buttonText: string;
    buttonLink: string;
  }>();
  constructor() {}

  ngOnInit() {
    // const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    // const block = formattedActualite.articleBlocks.find((block: any) => block.type === 6);
    // if (block) {
    //   this.buttonText = block.content.buttonText;
    //   this.buttonLink = block.content.buttonLink;
    //   this.onInputChange();
    // }
  }

  onInputChange() {
    this.inputChange.emit({
      buttonText: this.buttonText,
      buttonLink: this.buttonLink,
    });
  }
}
